/* lua.js generated code 0.3.0 */

var TreasureBoxItem = xClass("TreasureBoxItem", cc.Node)

TreasureBoxItem.create = function() {
    var self = this
    let b = TreasureBoxItem.new()

    b.init()
    return b
}

TreasureBoxItem.prototype.createNumLabel = function () {
    var self = this
    var numLabel = cc.LabelBMFont.create("x" + tostring(self.itemNum), "font/berlinsansfb_40_dropshadow.fnt")
    numLabel.setAnchorPoint(cc.p(0, 0))
    numLabel.setScale(1)
    self.numLabel = numLabel
    return self.numLabel
}
TreasureBoxItem.prototype.init = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    self.setAnchorPoint(0.5, 0.5)
    //yellow bg
    self.bg = cc.Sprite.createWithSpriteFrameName("treasureBox/yellow.png")
    self.addChild(self.bg)
    self.bg.setPosition(0,0)

    //red grey bg 	
    self.bgGrey = cc.Sprite.createWithSpriteFrameName("treasureBox/red1.png")
    self.addChild(self.bgGrey)
    self.bgGrey.setAnchorPoint(0.5, 1)
    self.bgGrey.setPosition(0, 88)
    self.bgRed = cc.Sprite.createWithSpriteFrameName("treasureBox/redbag2.png")
    self.addChild(self.bgRed)
    self.bgRed.setAnchorPoint(0.5, 1)
    self.bgRed.setPosition(0, 88)

    //物品数量
    self.itemNumTxt = cc.LabelBMFont.create("", "font/berlinsansfb_40_dropshadow.fnt")
    self.itemNumTxt.setAnchorPoint(cc.p(0.5, 0.5))
    self.itemNumTxt.setPosition(0, -35)
    self.itemNumTxt.setScale(0.7)
    self.addChild(self.itemNumTxt)
    
    //shareBtn
    // var shareSp = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/normal_newergo.png", cc.rect(20,15,10,10))
    var shareSp = cc.Sprite.createWithSpriteFrameName("uilibrary/b_green_cut.png")
    shareSp.setScale(0.7,0.6)
    // shareSp.setScale9Enabled(true)
    // shareSp.setPreferredSize(cc.size(135,65))
    // var shareSp = cc.Sprite.createWithSpriteFrameName("uilibrary/normal_newergo.png")
    self.shareBtn = UIGroupButton.create(shareSp)
    self.shareBtn.on(UIButtonEvent.Click, function () {
        TreasureBoxManager.getInstance().shareWX()
    })
    self.addChild(self.shareBtn)
    self.shareBtn.setPosition(4, -106)

    //greyBtn  	uilibrary/disabled_newergo.png
    var greySp = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/disabled_newergo.png", cc.rect(20,15,10,10))
    greySp.setScale9Enabled(true)
    greySp.setPreferredSize(cc.size(135,65))
    self.greyBtn = UIGroupButton.create(greySp)
    self.addChild(self.greyBtn)
    self.greyBtn.setPosition(2, -101)

    //getBtn
    // var getSp = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/b_blue_cut.png", cc.rect(86,51,3.2,2.7))
    var getSp = cc.Sprite.createWithSpriteFrameName("uilibrary/b_blue_cut.png")
    getSp.setScale(0.7,0.6)
    self.getBtn = UIGroupButton.create(getSp)
    self.getBtn.on(UIButtonEvent.Click, function () {
        TreasureBoxManager.getInstance().getReward(self.data.idx)
        DCAssist.userTrack("redbag", "click_receive_energe")
    })
    self.addChild(self.getBtn)
    self.getBtn.setPosition(2, -105)
    
    self.btnTxt = cc.Label.createWithSystemFont("领取", "Arial", 25)
    self.btnTxt.setAnchorPoint(cc.p(0.5, 0.5))
    self.addChild(self.btnTxt)
    self.btnTxt.setPosition(2, -99)

    //  真实分享标记
    self.isRealShare = MetaManager.isUseRealShareOnSpecialModule("redbag") || false;
}
TreasureBoxItem.prototype.showItemIcon = function() {
    var self = this
    // var itemIcon = UIItemBuilder.createPropIcon(self.itemId, self.expireTime)
    var itemIcon = UIItemBuilder.createPropIconWithoutTag(self.itemId)
    itemIcon.setPosition(0,0)
    let itemIconBtn = UIButton.create(itemIcon)
    itemIconBtn.on(UIButtonEvent.Click, function () {
        self.onClick()
    })
    self.addChild(itemIconBtn)
    self.itemIconBtn = itemIconBtn
    itemIconBtn.setScale(0.9)
    itemIconBtn.setPosition(0, 15)
    self.createNumLabel()
}
TreasureBoxItem.prototype.showPlayerIcon = function() {
    var self = this

    //玩家头像
    var playerIcon = new cc.Node()
    playerIcon.width = 100
    playerIcon.height = 100
    var icon = cc.Sprite.createWithSpriteFrameName("uilibrary/friendboard_head.png")
    icon.setScale(0.7)
    // var circle = cc.Sprite.createWithSpriteFrameName("uilibrary/tx01.png")
    var circle = cc.Sprite.createWithSpriteFrameName("uilibrary/friendboard_circle2.png")
    circle.setScale(0.7)
    playerIcon.addChild(icon)
    playerIcon.addChild(circle)
    var avatarUrl = self.data.helper.avatar
    HeadImageLoader.loadImage(icon, avatarUrl)
    self.playerIcon = playerIcon
    self.addChild(self.playerIcon)
    self.playerIcon.y = 10
  
    //玩家名字
    var playerNameTxt = cc.Label.createWithSystemFont(UIUtils.limitNameLength(self.data.helper.name || "", 4), "Arial", 25)
    playerNameTxt.setAnchorPoint(cc.p(0.5, 0.5))
    playerNameTxt.setScale(1)
    playerNameTxt.setAlignment(cc.TEXT_ALIGNMENT_CENTER)
    playerNameTxt.setColor(hex2ccc3("0x0C49A0", 16))  
    self.addChild(playerNameTxt)
    playerNameTxt.setPosition(0, 111)
    self.playerNameTxt = playerNameTxt
}
TreasureBoxItem.prototype.showByData = function (obj) {
    var self = this
    self.data = obj

    self.itemId = self.data.itemId
    self.itemNum = self.data.itemNum

    self.showItemIcon()

    //未有玩家帮助状态
    if(self.data.helper == null) {
        self.showEmpty()
    }
    //有玩家帮助，
    else if(self.data.helper!=null) {
        //助阵好友展示
        if (!self.isRealShare) {
            self.showPlayerIcon()
        }
        //已领奖
        if(self.data.rewardGet) {
            self.showGotten()
        }else { //但是没有领取奖励状态
            self.showFriendHelp()
        }
    }
    else{
        cc.warn("TreasureBoxItem state is wrong !")
    }
}

TreasureBoxItem.prototype.hideAll = function() {
    // return
    var self = this
    self.itemIconBtn.setVisible(false)
    if(self.playerIcon != null) {
        self.playerNameTxt.setVisible(false)
        self.playerIcon.setVisible(false)
    }
    
    self.bgRed.setVisible(false)
    self.bgGrey.setVisible(false)
    self.shareBtn.setVisible(false)
    self.itemNumTxt.setVisible(false)
    self.getBtn.setVisible(false)
    self.greyBtn.setVisible(false)
}
TreasureBoxItem.prototype.showEmpty = function() {
    var self = this
    self.hideAll()

    self.itemIconBtn.setVisible(true)
    self.shareBtn.setVisible(true)
    self.bgRed.setVisible(true)
    self.btnTxt.setString("索要")
    self.itemNumTxt.setVisible(true)
    self.itemNumTxt.setString("x" + self.data.itemNum)
}
TreasureBoxItem.prototype.showFriendHelp = function() {
    var self = this
    self.hideAll() 

    self.bgRed.setVisible(true)
    self.playerNameTxt.setVisible(!self.isRealShare)
    self.itemIconBtn.setVisible(true)
    self.itemNumTxt.setVisible(true)
    self.itemNumTxt.setString("x" + self.data.itemNum)
    self.playerIcon.setVisible(false)
    self.getBtn.setVisible(true)
    self.btnTxt.setString("领取")
}
TreasureBoxItem.prototype.showGotten = function() {
    var self = this
    self.hideAll()

    self.bgGrey && self.bgGrey.setVisible(true)
    self.greyBtn && self.greyBtn.setVisible(true)
    self.btnTxt && self.btnTxt.setString("已领取")
    self.playerNameTx && self.playerNameTxt.setVisible(!self.isRealShare)
    self.playerIcon && self.playerIcon.setVisible(!self.isRealShare)
    if (self.isRealShare) {
        self.itemIconBtn.setVisible(true)
        self.itemNumTxt.setVisible(true)
        self.itemNumTxt.setString("x" + self.data.itemNum)
    }
}
TreasureBoxItem.prototype.onClick = function () {
    var self = this
    // self.onClickCallback(self.bagId)
    cc.log("itemclick")
}
TreasureBoxItem.prototype.playSelectAnim = function () {
    var self = this
    self.icon.runAction(cc.Sequence.create(cc.ScaleTo.create(0.2, 1.1), cc.ScaleTo.create(0.2, 1.0)))
}
module.exports = TreasureBoxItem
